<!-- //
服务器表单添加
@auth xuyd
@date 2024-07-20
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="800px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="130px"
               class="form">
        <el-row class="flow-row">
          <el-form-item prop="serverName" label="服务名称">
            <el-input v-model="form.serverName" clearable maxlength="100" show-word-limit/>
          </el-form-item>
          <el-form-item prop="serverIp" label="IP地址">
            <el-input v-model="form.serverIp" clearable maxlength="30" show-word-limit/>
          </el-form-item>
          <el-form-item prop="bindNodeCode" label="绑定账号">
            <SelectorKeyValue v-model="form.bindNodeCode"
                              :clearable="true"
                              :datasource-list="$store.getters.dictType['REMOTE_SSH']"/>
          </el-form-item>
          <el-form-item prop="logPath" label="监控日志路径" maxlength="255" show-word-limit>
            <el-input v-model="form.logPath" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="monitorLogicDesc" label="监控逻辑描述">
            <el-input type="textarea" placeholder="监控逻辑描述"
                      v-model="form.monitorLogicDesc"
                      maxlength="500"
                      :autosize="{ minRows: 3, maxRows: 6}"
                      clearable
                      style="width: 100%"
                      show-word-limit/>
          </el-form-item>
          <el-form-item prop="bindBuildParamsScriptKey" label="构建参数脚本">
            <SelectorKeyValue v-model="form.bindBuildParamsScriptKey"
                              :clearable="true"
                              :datasource-list="$store.getters.dictType['VARIABLE_LIST']"/>
          </el-form-item>
          <el-form-item prop="bindShellScriptKey" label="监控执行脚本">
            <SelectorKeyValue v-model="form.bindShellScriptKey"
                              :clearable="true"
                              :datasource-list="$store.getters.dictType['VARIABLE_LIST']"/>
          </el-form-item>
          <el-form-item prop="cron" label="调度频率">
            <el-input
                placeholder="请输入调度频率，eg：0 50 19 * * ?"
                v-model="form.cron"
                clearable
                style="width: 100%"
                maxlength="30"/>
          </el-form-item>
          <el-form-item prop="status" label="上线状态">
            <el-radio-group v-model="form.status">
              <el-radio-button label="1">上线</el-radio-button>
              <el-radio-button label="0">下线</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button type="primary" size="small" @click="handleValidate" :loading="validateLoading">测 试</el-button>
      <el-button type="primary" size="small" @click="handleOk" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import AggDictApi from '@/api/aggDict.api.js';
import MonitorChannelApi from '@/api/sys/sysMonitorChannel.api.js';

const FORM_DEFINE = {
  serverName: null,
  serverIP: null,
  logPath: null,
  monitorLogicDesc: null,
  bindBuildParamsScriptKey: null,
  bindShellScriptKey: null,
  bindNodeCode: null,
  cron: null,
  status: 1,
};
export default {
  name: 'ViewMonitorServerEdit',
  dictTypes: [
    {
      dictType: "REMOTE_SSH",
      dataType: String,
      cache: true,
      requestGroup: "customDict",
      request: AggDictApi.selectMapCustomDict,
    },
    {
      dictType: "VARIABLE_LIST",
      dataType: String,
      cache: true,
      requestGroup: "customDict",
      request: AggDictApi.selectMapCustomDict,
    },
  ],
  data() {
    return {
      loading: false,
      validateLoading: false,
      visible: false,
      title: '新建监控任务',
      opts: {
        mode: null,
      },
      form: JSON.stringify(FORM_DEFINE),
      rules: {
        serverName: [{required: true, message: "请输入服务名称", trigger: 'blur'}],
        serverIp: [{required: true, message: "请输入IP地址", trigger: 'blur'}],
        bindNodeCode: [{required: true, message: "请选择绑定账号", trigger: 'change'}],
        logPath: [{required: true, message: "请输入监控日志路径", trigger: 'blur'}],
        bindBuildParamsScriptKey: [{required: true, message: "请选择构建参数脚本", trigger: 'change'}],
        bindShellScriptKey: [{required: true, message: "请选择监控执行脚本", trigger: 'change'}],
      },
    }
  },
  computed: {
    editMode() {
      return this.opts.mode === 2;
    }
  },
  methods: {
    showModal({data, mode, title, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        mode: mode,
        title: title,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      // console.log("===========>", opts)
      this.visible = true;
      this.opts.mode = opts.mode
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(FORM_DEFINE, opts.data)
      this.form = opts.data
      this.title = opts.title
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 测试连通性
     */
    handleValidate() {
      this.validateLoading = true;
      MonitorChannelApi.validateConn(this.form).then(resp => {
        this.validateLoading = false;
        if (resp.data) {
          this.$modal.msgSuccess("连接成功")
        } else {
          this.$modal.msgError("连接失败")
        }
      }).catch(err => {
        this.validateLoading = false;
      })
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.loading = true;
          return MonitorChannelApi.saveMonitorServer(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("保存成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          }).catch(() => {
            this.loading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  padding-right: 50px;
}
</style>
